import { ClaimDailyRewardsSeasonThreeResponse } from "../../types/rewards";

export const claimDailyRewardsSeasonThreeModel = (
  response: ClaimDailyRewardsSeasonThreeResponse
): ClaimDailyRewardsSeasonThreeResponse => response;
